module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-0a6510b2747fa13c116e3fe4318008de.png";